import * as React from 'react';
import './index.css'
import DefaultSpaceUserModeLayout from './DefaultSpaceUserModeLayout'
import DefaultSpaceLiveModeLayout from "./DefaultSpaceLiveModeLayout";
import DecorationSpaceUserMode from "./DecorationSpaceUserModeLayout";
import DecorationSpaceLiveMode from './DecorationSpaceLiveModeLayout'
import { useSpaceState } from "../userHooks";

const Gui = () => {
    const [spaceState] = useSpaceState()
    
    const renderDefaultSpaceUserMode = () => <DefaultSpaceUserModeLayout/>
    const renderDefaultSpaceLiveMode = () => <DefaultSpaceLiveModeLayout/>

    const renderDefaultSpaceTourMode = () => {
        return <div className="panel default-space-panel__bottom--tour">default -- tour</div>
    }

    const renderDecorationSpaceUserMode = () => <DecorationSpaceUserMode/>

    const renderDecorationSpaceLiveMode = () => <DecorationSpaceLiveMode/>

    const renderDecorationSpaceTourMode = () => {
        return <div className="panel decoration-space-panel__bottom--tour">decoration -- tour</div>
    }

    switch(spaceState.type){
        case 'default':
            return defaultSpacePanel()
        case 'decoration':
            return decorationSpacePanel()
        default:
            return null
    }

    function defaultSpacePanel () {
        switch (spaceState.mode) {
            case 'user':
                return renderDefaultSpaceUserMode()
            case 'live':
                return renderDefaultSpaceLiveMode()
            case 'tour':
                return renderDefaultSpaceTourMode()
            default:
                return null
        }
    }

    function decorationSpacePanel () {
        switch (spaceState.mode) {
            case 'user':
                return renderDecorationSpaceUserMode()
            case 'live':
                return renderDecorationSpaceLiveMode()
            case 'tour':
                return renderDecorationSpaceTourMode()
            default:
                return null
        }
    }
};

export default Gui;
